export const AdminLocationImageMapHook: {
  el?: HTMLElement
  abortController?: AbortController
  mounted: () => void
  destroyed: () => void
  unMountComponent?: (() => void) | undefined
  isDestroyed?: boolean
} = {
  mounted() {
    if (!this.el) {
      return
    }

    const rootElement = this.el

    void import('../../react/views/AdminLocationImageLiveEditView')
      .then(({ AdminLocationImageLiveEditView }) => {
        if (this.isDestroyed) {
          return
        }

        this.unMountComponent = AdminLocationImageLiveEditView({ rootElement, liveView: this })
      })
      .catch((error) => {
        console.error('[AdminLocationImageMapHook] Failed to load map view:', error)
      })
  },
  destroyed() {
    this.isDestroyed = true
    this.unMountComponent?.()
  },
}
